import LookupReferenceDataItemChip from "./LookupReferenceDataItemChip";

export default LookupReferenceDataItemChip;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/LookupReferenceDataItemChip/index.tsx